import { bible } from '../../bible.js';
import { normal } from '../../normal.js';
import { global } from '../../global.js';
import './footer.js';
import './header.js';
import { FASTElement, html, customElement } from '@microsoft/fast-element';
const template = html<AppPage>`
  <main>
    <section>
    <slot></slot>
    </section>
  </main>
`;
@customElement({
  name: 'app-page',
  template,
  styles: [ bible, normal, global ]
})
export class AppPage extends FASTElement {}

